export default __webpack_public_path__ + "static/media/Subtract.c0b5d21d.svg";